
import React from 'react';
import DynamicEditForm from '../../components/DynamicEditForm/DynamicEditForm.js'; // Import your form component
import {getStoredData} from "../../JsonFiles/fetchData";

const EditServicesPage = () => {
  const fields = getStoredData()?.["11"]?.AdminServices ?? {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/services'; // API URL for fetching/editing product
  const successRedirect = '/admin/services'; // Where to redirect after a successful update

  return (
    <div>
      <DynamicEditForm
        fields={fields}
        apiUrl={apiUrl}
        successRedirect={successRedirect}
      />
    </div>
  );
};

export default EditServicesPage